<p-dropdown
  [(ngModel)]="country"
  [options]="countries"
  [placeholder]="country!.trMsg | translate: { placeholder: 'Select a country' }"
  optionLabel="trMsg"
  filterBy="trMsg"
  class="fix"
  [showClear]="false"
  [virtualScroll]="false"
  [filter]="true"
  (onChange)="onCountryChanged()"
  [dropdownIcon]="dropdownIcon()"
>
  <ng-template let-country pTemplate="item">
    <a role="button" tabindex="0" (keydown)="onEnterItem($event)">
      <span>{{ country.trMsg | translate }}</span>
    </a>
  </ng-template>
</p-dropdown>
